export const CONTRACT_ADDRESS = '0xDf643ffB8CA76e428827873E6097C8598C60cC3a';
